require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-how-can-peru-make-sure-its-most-marginalized-citizens.json") })
        }
      }, "path---en-us-project-how-can-peru-make-sure-its-most-marginalized-citizens");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-how-can-peru-make-sure-its-most-marginalized-citizens!./.cache/json/en-us-project-how-can-peru-make-sure-its-most-marginalized-citizens.json
// module id = 517
// module chunks = 231608221292675